import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { ActionButton, AntdRadioButton, Filters, RadioOptions } from "./styles";
import { Space, Dropdown, Menu, Modal, Radio } from "antd";
import {
	CloseCircleOutlined,
	PlusOutlined,
	InfoCircleOutlined,
} from "@ant-design/icons";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import debounce from "lodash/debounce";
import { BsThreeDotsVertical } from "react-icons/bs";
import LoadingHeader from "./components/LoadingHeader";
import AntdSearch from "../../../../common/antd-search/AntdSearch";
import {
	get_access_types_header_info,
	get_access_types_page,
	update_access_type_state,
} from "../../../../../api/endpoints/accessTypes";
import PrimaryButton from "../../../../common/antd-buttons/PrimaryButton";

const { confirm } = Modal;

export default function AccessTypesList() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [headerInfo, setHeaderInfo] = useState(null);
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "name",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/administrationAccess/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="terciary" fontWeight={600} fontSize={14}>
						{value.toUpperCase()}
					</Typo>
				</Link>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Descripcion</div>,
			dataIndex: "description",
			render: (value, record) => (
				<Typo type="muted" fontWeight={600} fontSize={14}>
					{value}
				</Typo>
			),
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 10,
			render: (f, r, i) => (
				<>
					<Dropdown
						overlay={!r.deleted ? menu : menuInactive}
						placement="bottomRight"
					>
						<ActionButton key={`${f}`} onMouseOver={() => setKey(f)}>
							<BsThreeDotsVertical />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/administrationAccess/${key}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleDelete(key)}>Borrar</Typo>,
				},
			]}
		/>
	);

	const menuInactive = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/administrationAccess/${key}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleActivate(key)}>Habilitar</Typo>,
				},
			]}
		/>
	);

	const fetch_data_access_types = async (page, search) => {
		const res = await get_access_types_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_access_types(1);
	}, [state]);

	const fetch_access_types_header = async () => {
		const res = await get_access_types_header_info();
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_access_types_header();
	}, [state]);

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		fetch_data_access_types(1, e.target.value);
	};

	const debouncedEventHandler = useMemo(() => debounce(eventHandler, 250), []);

	const handleDelete = (key) => {
		confirm({
			title: "¿Seguro que quiere eliminar este Tipo de Acceso?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "El Tipo de Acceso será eliminado al aceptar",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				deleteActiveIngredient(key);
			},
		});
	};

	const deleteActiveIngredient = async (id) => {
		const _state = { id: id, state: "DELETED" };
		await update_access_type_state(id, _state);
		fetch_data_access_types(1, "");
		fetch_access_types_header();
	};

	const handleActivate = (key) => {
		confirm({
			title: "¿Seguro que quiere activar este Tipo de Acceso?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "El Tipo de Acceso será reactivado al aceptar",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				activateActiveIngredient(key);
			},
		});
	};

	const activateActiveIngredient = async (id) => {
		const _state = { id: id, state: "ACTIVATED" };
		await update_access_type_state(id, _state);
		fetch_data_access_types(1, "");
		fetch_access_types_header();
	};

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de Tipos de Acceso
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters>
					{!headerInfo ? (
						<LoadingHeader />
					) : (
						<Main.FilterContainer>
							<AntdSearch
								width={400}
								allowClear
								height={35}
								placeholder="Buscar Tipo de Acceso"
								onChange={debouncedEventHandler}
							/>
							<RadioOptions>
								<Radio.Group
									value={state}
									onChange={(e) => setState(e.target.value)}
								>
									<AntdRadioButton value="ACTIVE">
										Activo ({headerInfo?.totalActive})
									</AntdRadioButton>
									<AntdRadioButton value="DELETED">
										Inactivo ({headerInfo?.totalDisabled})
									</AntdRadioButton>
								</Radio.Group>
							</RadioOptions>
							<Main.FilterActions>
								<PrimaryButton
									icon={<PlusOutlined />}
									onClick={() =>
										navigate("/admin/administrationAccess/create?uri=" + uri)
									}
									style={{ width: "200px", fontWeight: "400" }}
								>
									Crear Tipo de Acceso
								</PrimaryButton>
							</Main.FilterActions>
						</Main.FilterContainer>
					)}
				</Filters>

				<DataTable
					data={data}
					fetch={fetch_data_access_types}
					columns={columns}
					containerMarginTop={"0px"}
				/>
			</Main.Body>
		</Main>
	);
}
